export default __webpack_public_path__ + "static/media/bootstrapper-5.32c48d37.png";